define('actions/shared-entities',[
    "jquery",
    "underscore",
    "backbone",
    "dispatcher/AppDispatcher",
    "constants/actiontypes",
    "shared/crm"
], 
function ($, _, Backbone, AppDispatcher, Constants, CRM) {
    return Backbone.Model.extend({
        init: function(params) {
        },
        addShared: function (params) {
            AppDispatcher.dispatch({
                actionType: Constants.CREATED_SHARED_ENTITY,
                data: params
            });
        },
        deletedItem: function(guid) {
            AppDispatcher.dispatch({
                actionType: Constants.DELETED_SHARED_ENTITY,
                guid: guid
            });
        },
        pull: function (options, onComplete) {
            var shared = [];
            var self = this;

            window.api.request("share", options).each(function iterator(index, item) {
                shared.push({
                    title: item.data.entity.title,
                    guid: item.data.entity.guid,
                    sender: item.data.sender,
                    created_at: new Date(item.data.created_at),
                    type: item.data.entity_type,
                    links: item.links
                });
            }, function () {
                self.addShared(shared);
                if (typeof onComplete === "function") {
                    onComplete();
                }
            });
        },
        /**
         * Action to pull teams from API. On complete add meetings to store
         * @author Tim Lee
         * @dateCreated 04/28/20
         */
        pullTeams: function (options, onComplete) {
            var sharedMeetinglist = []
            var self = this;

            window.api.request("share", options).each(function iterator(index, meetingData) {
                meeting = JSON.parse(meetingData.data.context.replace(/(^\"+|\"+$)/mg, ''));
                meeting['guid'] = meetingData.data.entity_guid;
                meeting['type'] = "teams.meeting";
                sharedMeetinglist.push(meeting);
            }, function () {
                self.addShared(sharedMeetinglist);
                if (typeof onComplete === "function") {
                    onComplete();
                }
            });
        },
        delete: function(guid, type, receivers) {
            var self = this;
            window.api.request("share")
            .delete({
                entity_type: type,
                entity_guid: guid,
                receivers: receivers
            })
            .done(function (response) {
                self.deletedItem(guid);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.error(jqXHR);
                alert("Uh-Oh!", jqXHR.responseText || "Your request could not be completed at this time.", {
                    message: "Close"
                });
            });
        },
        duplicate: function(item, onComplete, onFail) {
            var self = this;
            window.api.request(item.type+"s", item.guid, "duplicate").create({})
            .done(function (response) {
                if (typeof onComplete === "function") {
                    onComplete(item.type, response.links);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                if (typeof onFail === "function") {
                    onFail();
                }

                if (jqXHR.status == 423) {
                    window.showBunceesLimitModal();
                }
                if (jqXHR.status == 403) {
                    window.toast('This Buncee is not copyable.');
                }
            });
        }
    });
});
